import get from 'lodash/get'
import * as React from 'react'
import * as ReactStrap from 'reactstrap'
import * as RasaInput from '../rasa-input'
import './styles.css'

// This overriding of types OFFENDS ME GREATLY.
interface DropdownProps {
  data: Array<(RasaInput.DropdownOption | string)>,
  name: string,
  onChange: (e: RasaInput.DropdownOnChangeArg) => void,
  selected: RasaInput.DropdownKey,
}

export const Dropdown = ({data, name, onChange, selected}: DropdownProps) =>
<ReactStrap.Input type="select"
                  value={selected}
                  onChange={(e) => onChange({name, value: e.target.value})}>
  {data.map((d, i) =>
    <option key={get(d, 'key', d) + i + 'Drop'} value={get(d, 'key', d)}>
      {get(d, 'description', d)}
    </option>)}
</ReactStrap.Input>



// WEBPACK FOOTER //
// ./src/components/modal/components.tsx